<template>
  <div>
    <v-container v-if="isPermissionCanView" fluid>
      <v-row class="mb-1">
        <v-col cols="auto">
          <div class="text-h5 mt-1">นำออกงานเดินรถ</div>
        </v-col>
      </v-row>

      <CustomCardFormViewModern
        title="ตัวกรองข้อมูล"
        :isShowTitle="true"
        :isTitleHighlight="true"
        :setPaddingToCardText="true"
      >
        <!-- ประเภทข้อมูล -->
        <v-row no-gutters class="px-9 pt-5 pb-2">
          <v-col cols="12">
            <InputView title="ประเภทข้อมูล" :isRequired="true">
              <v-radio-group
                v-model="dataType"
                row
                hide-details
                class="mt-1"
                @change="onDataTypeChange"
              >
                <v-radio label="งานเดินรถ" value="contractJob"></v-radio>
                <v-radio label="งานที่จบโดย Admin" value="adminEnded"></v-radio>
              </v-radio-group>
            </InputView>
          </v-col>
        </v-row>

        <v-divider class="mx-6"></v-divider>

        <!-- Filters (ใช้ร่วมกันทั้ง 2 ประเภท) -->
        <v-row no-gutters class="px-6 pt-5 pb-4">
          <v-col cols="12" lg="3" class="px-3">
            <InputView title="วันที่เริ่มงานเริ่มต้น" :isRequired="true">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    placeholder="เลือกวันที่"
                    class="app-custom-input custom-placeholer-color"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="startDateMenu = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </InputView>
          </v-col>
          <v-col cols="12" lg="3" class="px-3">
            <InputView title="วันที่เริ่มงานสิ้นสุด" :isRequired="true">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDate"
                    placeholder="เลือกวันที่"
                    class="app-custom-input custom-placeholer-color"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="endDateMenu = false"
                  locale="th"
                ></v-date-picker>
              </v-menu>
            </InputView>
          </v-col>
          <v-col cols="12" lg="3" class="px-3" v-if="dataType === 'contractJob'">
            <InputView title="สถานะ">
              <v-select
                v-model="selectedStatus"
                :items="statusList"
                item-text="text"
                item-value="value"
                placeholder="เลือกสถานะ"
                class="app-custom-input custom-placeholer-color"
                outlined
                dense
                hide-details
                clearable
              ></v-select>
            </InputView>
          </v-col>
          <v-col cols="12" lg="3" class="px-3" v-if="dataType === 'contractJob'">
            <InputView title="รับเข้า-รับออก">
              <v-select
                v-model="selectedDirection"
                :items="directionList"
                item-text="text"
                item-value="value"
                placeholder="เลือกรับเข้า-รับออก"
                class="app-custom-input custom-placeholer-color"
                outlined
                dense
                hide-details
                clearable
              ></v-select>
            </InputView>
          </v-col>
        </v-row>

        <template v-if="dataType === 'contractJob'">
          <v-divider class="mx-6"></v-divider>

          <v-row no-gutters class="px-6 pt-5 pb-4">
            <v-col cols="12" lg="6" class="px-3">
              <InputView title="สัญญา">
                <v-autocomplete
                  v-model="selectedContract"
                  :items="contractList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกสัญญา"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
            <v-col cols="12" lg="6" class="px-3">
              <InputView title="บริษัท/โรงงาน">
                <v-autocomplete
                  v-model="selectedCompany"
                  :items="companyList"
                  placeholder="เลือกบริษัท/โรงงาน"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
          </v-row>

          <v-divider class="mx-6"></v-divider>

          <v-row no-gutters class="px-6 pt-5 pb-4">
            <v-col cols="12" lg="4" class="px-3">
              <InputView title="พนักงานขับรถ">
                <v-autocomplete
                  v-model="selectedDriver"
                  :items="driverList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกพนักงานขับรถ"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
            <v-col cols="12" lg="4" class="px-3">
              <InputView title="ทะเบียนรถ">
                <v-autocomplete
                  v-model="selectedVehicle"
                  :items="vehicleList"
                  item-text="displayLabel"
                  item-value="_id"
                  placeholder="เลือกทะเบียนรถ"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </InputView>
            </v-col>
            <v-col cols="12" lg="4" class="px-3">
              <InputView title="ประเภทรถ">
                <v-select
                  v-model="selectedVehicleType"
                  :items="vehicleTypeList"
                  item-text="label"
                  item-value="key"
                  placeholder="เลือกประเภทรถ"
                  class="app-custom-input custom-placeholer-color"
                  outlined
                  dense
                  hide-details
                  clearable
                ></v-select>
              </InputView>
            </v-col>
          </v-row>

          <div class="px-9 pb-3">
            <span class="red--text text-app-small">* ถ้าว่างไว้หมายถึงเงื่อนไขทั้งหมด</span>
          </div>
        </template>
        <v-divider></v-divider>
        <v-row no-gutters class="px-9 py-4" align="center">
          <v-col cols="auto" v-if="dataType === 'contractJob'">
            <InputView title="รูปแบบการนำออก" :isRequired="true">
              <v-radio-group
                v-model="exportType"
                row
                hide-details
                class="mt-1"
              >
                <v-radio
                  label="วางบิลและชำระเงิน"
                  value="billing"
                ></v-radio>
                <v-radio
                  label="ข้อมูลทั้งหมด"
                  value="full"
                ></v-radio>
              </v-radio-group>
            </InputView>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" :class="dataType === 'contractJob' ? 'pt-7' : ''">
            <PrimaryButton
              icon="mdi-download"
              :disabled="!startDate || !endDate"
              :loading="exportLoading"
              @on-click="exportCSV"
            >
              นำออก CSV
            </PrimaryButton>
          </v-col>
        </v-row>
      </CustomCardFormViewModern>
    </v-container>
    <AppPageNotFound :show="isPermissionCanView" />

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AppPageNotFound from "@/components/AppPageNotFound.vue";
import CustomCardFormViewModern from "@/components/CustomCardFormViewModern.vue";
import InputView from "@/components/InputView.vue";
import PrimaryButton from "@/components/PrimaryButton.vue";
import {
  getExportContracts,
  getExportCompanies,
  getExportDrivers,
  getExportVehicles,
  getExportVehicleTypes,
  getExportContractJob,
  getExportContractJobAdminEnded,
} from "@/services/api/export_data";
import moment from "moment";

export default {
  name: "ExportContractJobView",
  components: {
    AppPageNotFound,
    CustomCardFormViewModern,
    InputView,
    PrimaryButton,
  },
  data() {
    return {
      isPermissionCanView: false,
      exportLoading: false,
      dataType: "contractJob",
      //
      contractList: [],
      companyList: [],
      driverList: [],
      vehicleList: [],
      vehicleTypeList: [],
      //
      selectedContract: null,
      selectedCompany: null,
      selectedStatus: "SUCCESS",
      selectedDirection: null,
      selectedVehicleType: null,
      selectedDriver: null,
      selectedVehicle: null,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      startDateMenu: false,
      endDateMenu: false,
      exportType: "billing",
      //
      statusList: [
        { text: "วางแผน", value: "PLANNING" },
        { text: "เตรียมการ", value: "PREPARING" },
        { text: "ยืนยันแล้ว", value: "CONFIRM" },
        { text: "กำลังดำเนินการ", value: "PROCESS" },
        { text: "สำเร็จ", value: "SUCCESS" },
        { text: "ยกเลิก", value: "CANCEL" },
      ],
      directionList: [
        { text: "รับเข้า", value: "รับเข้า" },
        { text: "รับออก", value: "รับออก" },
      ],
      //
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  mounted() {
    this.checkUserPermissions();
    if (this.isPermissionCanView) {
      this.loadFilterOptions();
    }
  },
  methods: {
    checkUserPermissions() {
      if (this.$store.getters.userInfo !== null) {
        let permissions = this.$store.getters.userInfo.permissions;
        if (
          permissions &&
          (permissions.includes("ADMIN_ALL") ||
            permissions.includes("EXPORT_DATA_VIEW"))
        ) {
          this.isPermissionCanView = true;
        }
      }
    },

    onDataTypeChange() {
      // reset exportType when switching data type
      this.exportType = "billing";
    },

    async loadFilterOptions() {
      const [contracts, companies, drivers, vehicles, vehicleTypes] =
        await Promise.all([
          getExportContracts(this.$store),
          getExportCompanies(this.$store),
          getExportDrivers(this.$store),
          getExportVehicles(this.$store),
          getExportVehicleTypes(this.$store),
        ]);

      if (contracts.code === 200 && contracts.data) {
        this.contractList = contracts.data.map((c) => ({
          ...c,
          displayLabel: `${c.contractNumber} : ${c.title}`,
        }));
      }

      if (companies.code === 200 && companies.data) {
        this.companyList = companies.data;
      }

      if (drivers.code === 200 && drivers.data) {
        this.driverList = drivers.data;
      }

      if (vehicles.code === 200 && vehicles.data) {
        this.vehicleList = vehicles.data;
      }

      if (vehicleTypes.code === 200 && vehicleTypes.data) {
        this.vehicleTypeList = vehicleTypes.data;
      }
    },

    async exportCSV() {
      if (!this.startDate || !this.endDate) return;
      this.exportLoading = true;
      try {
        const params = {
          startDate: this.startDate,
          endDate: this.endDate,
          contractId: this.selectedContract,
          status: this.selectedStatus,
          company: this.selectedCompany,
          driverId: this.selectedDriver,
          vehicleId: this.selectedVehicle,
          vehicleType: this.selectedVehicleType,
          direction: this.selectedDirection,
        };

        let resp;
        if (this.dataType === "adminEnded") {
          resp = await getExportContractJobAdminEnded(this.$store, params);
        } else {
          params.exportType = this.exportType;
          resp = await getExportContractJob(this.$store, params);
        }

        if (resp.code === 200 && resp.data) {
          const records = resp.data.records;
          if (records.length === 0) {
            this.showSnackbar("ไม่มีข้อมูลสำหรับนำออก", "warning");
            this.exportLoading = false;
            return;
          }

          const headers = Object.keys(records[0]);
          const csvRows = [headers.join(",")];
          for (const row of records) {
            const values = headers.map((h) => {
              let val = row[h];
              if (val === null || val === undefined) return "";
              val = String(val).replace(/"/g, '""');
              return `"${val}"`;
            });
            csvRows.push(values.join(","));
          }
          const csvContent = csvRows.join("\n");
          const blob = new Blob(["\uFEFF" + csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `งานเดินรถ_${this.startDate}_${this.endDate}.csv`;
          a.click();
          URL.revokeObjectURL(url);
          this.showSnackbar(
            `นำออกสำเร็จ ${records.length} รายการ`,
            "success"
          );
        }
      } catch (err) {
        this.showSnackbar("ไม่สามารถนำออกข้อมูลได้", "error");
      }
      this.exportLoading = false;
    },

    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>
